import { SessionType } from '@mprolab/sdk'

interface GetApiHeadersParams {
  contentType?: string
  accessToken?: string
  account?: string
  userId?: string
  hash?: string
  blobType?: string
  blobContent?: string
  sessionType?: SessionType
}

const getApiHeaders = ({
  contentType,
  accessToken,
  account,
  userId,
  hash,
  blobType,
  blobContent,
  sessionType
}: GetApiHeadersParams): {
  Accept: string
  'Content-Type': string
  Authorization?: string
  'x-account-wallet'?: string
  'x-account-login-hash'?: string
  'x-account-UserId'?: string
  'x-ms-blob-type'?: string
  'x-ms-blob-content'?: string
  'x-session-type'?: string
} => {
  return {
    Accept: '*/*',
    'Content-Type': contentType || 'application/json',
    ...(accessToken && { Authorization: accessToken }),
    ...(account && { 'x-account-wallet': account.toLowerCase() }),
    ...(hash && { 'x-account-login-hash': hash }),
    ...(userId && { 'x-account-UserId': userId }),
    ...(blobType && { 'x-ms-blob-type': blobType }),
    ...(blobContent && { 'x-ms-blob-content': blobContent }),
    ...(sessionType && { 'x-session-type': sessionType })
  }
}

export default getApiHeaders
